import type { ReactNode } from "react";
import { Switch } from "../../../../components/Switch/Switch.tsx";
import { PanelSubsection } from "./PanelSubsection.tsx";

export const SwitchSubsection = ({
  value,
  onChange,
  switchName,
  className,
  isBeta = false,
  infoContent,
  children,
}: {
  value: boolean;
  onChange: (value: boolean) => void;
  switchName: string;
  className?: string;
  isBeta?: boolean;
  infoContent?: ReactNode;
  children?: ReactNode;
}) => (
  <PanelSubsection
    title={switchName}
    rightItem={<Switch value={value} onChange={onChange} />}
    className={className}
    isBeta={isBeta}
    infoContent={infoContent}
  >
    {children}
  </PanelSubsection>
);
